import { TextField } from "@mui/material";
import React from "react";
import MenuItem from "@mui/material/MenuItem";
import { STATES } from "../../constants";
import { formatToPhoneNumber } from "../../utils/formatFormFields";

export const ClinicDetailsFields = ({ data, errors, onChange }) => {
  return [
    {
      id: "clinic_name",
      headerTitle: "Clinic Details",
      input: (
        <TextField
          id="clinic_name"
          label="Clinic name"
          onChange={onChange("clinic_name", null, data)}
          value={data?.clinic_name ?? ""}
          fullWidth
        />
      ),
      cols: 12,
    },
    {
      id: "phone_number",
      tab: 0,
      input: (
        <TextField
          label="Phone number"
          id="phone_number"
          onChange={onChange("phone_number", "phoneNumberchange", data)}
          value={formatToPhoneNumber(data?.phone_number ?? "")}
          variant="outlined"
          size="small"
          fullWidth
          inputProps={{ maxLength: 14 }}
        />
      ),
    },
    {
      id: "fax_number",
      tab: 0,
      input: (
        <TextField
          label="Fax number (optional)"
          id="fax_number"
          onChange={onChange("fax_number", "phoneNumberchange", data)}
          value={formatToPhoneNumber(data?.fax_number ?? "")}
          variant="outlined"
          size="small"
          fullWidth
          inputProps={{ maxLength: 14 }}
        />
      ),
    },
    {
      id: "address",
      tab: 0,
      input: (
        <TextField
          id="address"
          name="address"
          autoComplete="off"
          value={data?.address ?? ""}
          onChange={onChange("address", null, data)}
          variant="outlined"
          label="Address"
          fullWidth
          inputProps={{ maxLength: 1000 }}
        />
      ),
    },
    {
      id: "address_2",
      tab: 0,
      input: (
        <TextField
          id="address_2"
          name="address_2"
          autoComplete="off"
          value={data?.address_2 ?? ""}
          onChange={onChange("address_2", null, data)}
          variant="outlined"
          label="Address 2 (optional)"
          fullWidth
          inputProps={{ maxLength: 1000 }}
        />
      ),
    },
    {
      id: "city",
      tab: 0,
      input: (
        <TextField
          id="city"
          label="City"
          onChange={onChange("city", null, data)}
          value={data?.city ?? ""}
          fullWidth
          inputProps={{ maxLength: 255 }}
        />
      ),
      cols: 12,
    },
    {
      id: "state",
      tab: 0,
      input: (
        <TextField
          id="state"
          select
          label="State"
          onChange={onChange("state", null, data)}
          value={data?.state ?? ""}
          fullWidth
          autoComplete="off"
        >
          <MenuItem disabled value={""}>
            Select
          </MenuItem>
          {Object.keys(STATES).map((key) => {
            return (
              <MenuItem key={key} value={key}>
                {STATES[key]}
              </MenuItem>
            );
          })}
        </TextField>
      ),
    },
    {
      id: "zip_code",
      tab: 0,
      input: (
        <TextField
          id="zip_code"
          label="ZIP code"
          placeholder="23226"
          onChange={onChange("zip_code", "zipCode", data)}
          value={data?.zip_code ?? ""}
          fullWidth
          inputProps={{ maxLength: 5 }}
          helperText={
            errors["zip_code"]
              ? "Please enter ZIP Code"
              : errors["zip_format_error"]
                ? "Invalid ZIP Code"
                : ""
          }
        />
      ),
      cols: 12,
    },
    {
      id: "website",
      input: (
        <TextField
          id="website"
          placeholder="health.com"
          label="Website (optional)"
          onChange={onChange("website", null, data)}
          value={data?.website ?? ""}
          fullWidth
        />
      ),
      cols: 12,
      divider: true,
    },
  ];
};
